import React, { useEffect, useRef, useState, type ReactElement } from "react";
import { useStakeStore } from "../../state";
import { useEscrowStore, } from "@stores/escrow";
import { SectionHeading } from "../../components";
import {Loader} from "@bracket/react-loader";
import { GameScreen } from "@bracket/in-or-out";

import "./Play.scss";
import { wagmiConfig } from "@config";
import { useAccount } from "wagmi";

export const Play = (): ReactElement => {
  const state = useStakeStore();
  const {
    user_stake,
    initialized,
    initializing,
    initialize,
  } = useEscrowStore();
  const { address } = useAccount();

  const refAddress = useRef(address);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    if (address !== refAddress.current) {
      setReload(true);

      setTimeout(() => {
        refAddress.current = address;
        setReload(false);
      }, 500);
    }
  }, [address]);

  useEffect(() => {
    if(!initialized && !initializing) {
      initialize();
    }
  }, [])

  if(!initialized) {
    return (
      <div className="play-loader-panel">
        <Loader />
      </div>
    );
  }

  return (
    <div className="play" key={address}>
      {refAddress.current && !reload ? (
        <GameScreen
          wagmiConfig={wagmiConfig}
          address={refAddress.current}
          user_stake={user_stake}
        />
      ) : (
        <div>{reload ? "" : "Wallet not connected"}</div>
      )}
      {/* <SectionHeading name="Play" /> */}
    </div>
  );
};
